import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';

import { EventService } from './event.service';

@Injectable()
export class ErrorService {

    constructor(
        private eventService: EventService,
        private router: Router
    ) { }

    errorCodeTranslations = {
      'USER_EMAIL_NOT_UNIQUE'  : 'Email address already taken'
    };

    hasErrorCodeTranslation(errorCode) {
        return !!errorCode && this.errorCodeTranslations.hasOwnProperty(errorCode);
    }

    translateErrorCode(errorCode) {
        if (errorCode && this.errorCodeTranslations.hasOwnProperty(errorCode)) {
            return this.errorCodeTranslations[errorCode];
        }
        return null;
    }

    handle400Error(status: number) {
        switch (status) {
            case 401: return 'Bad Request, please check your request';
            case 401: return 'Unauthorized. Please login';
            case 403: return 'Forbidden. You might not have the necessary permissions for this request';
            case 404: return 'Element not found. Either the Requested Element doesn\'t exist or you don\'t have the required permission';
            case 404: return '(http) Method not allowed.';
            case 409: return 'Data conflict. Please check your request data';
            case 415: return 'Unsupported Media Type. Please check API the documentation';
            default: return 'status not mapped';
        }
    }

    checkHttpStatus(status: number, login?: boolean) {
        switch (status) {
            case 0: return 'Could not connect to ' + (login ? 'Login' : 'AntiCheat') + ' Service';
            case 401: return (login ? 'Bad credentials. Please make sure you entered the correct email and password.' : 'Unauthorized. Please login');
            case 403: return (login ? 'User is inactive. Please contact your vendor.' : 'Forbidden. You might not have the necessary permissions for this request');
            case 404: return (login ? 'Login' : 'Endpoint') + ' currently not available';
            default: return 'status not mapped';
        }
    }

    handleAuthError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<any> => {
            error.message = this.checkHttpStatus(error.status, true);
            throw error;
        };
    }

    translateError(error): any {
        switch (error.status) {
            case 0:
                error.message = 'Could not connect to AntiCheat Service.';
                return error;
            case 400:
                if (error.error && this.hasErrorCodeTranslation(error.error.errorCode)) {
                    error.message = this.translateErrorCode(error.error.errorCode);
                }
                return error;
            case 401:
                error.message = 'unauthorized';
                this.router.navigate(['/login']);
                return error;
            case 403:
                error.message = 'Forbidden. You might not have the necessary permissions for this request';
                return error;
            case 404:
                error.message = 'backend service currently not available';
                return error;
            case 405:
                error.message = 'METHOD not implemented';
                return error;
            case 500:
                error.message = 'Internal error occurred';
                return error;
        }
        if (error.error) {
            const e = error.error;
            error.message = e.message + (e.additionalMessage ? ' -> ' + e.additionalMessage : '');
        }
        return error;
    }

    handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<any> => {
            error = this.translateError(error);
            if (error.status === 0) {
                this.eventService.info(`${error.message}`);
            } else {
                this.eventService.error(`${operation} failed: ${error.message}`);
            }
            this.eventService.logConsole(`${operation} failed: ${error.message}`);
            this.eventService.logRemote(`${operation} failed`, error.error).subscribe();
            throw error.error;
            // if (error.error) {
            //     return of(error.message as StatusResponse);
            // }
            // Let the app keep running by returning an empty result.
            // return of(error as T);

        };
    }
}
